import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import { RadioButton, InlineError, Box, Text } from "@shopify/polaris";
import Stack from "../../Stack";
import styled from "styled-components";

RHFRadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};

const CustomRadioButton = styled(RadioButton)`
  .Polaris-Choice {
    padding: 0 !important;
  }
`;

export default function RHFRadioGroup({
  name,
  options,
  flexDirection = "column",
  spacing = "20px",
  disabled,
  defaultValue,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue ?? options[0]?.value}
      render={({ field, fieldState: { error } }) => (
        <Stack flexDirection={flexDirection} spacing={spacing}>
          {options.map((option) => (
            <Stack key={option.value} flexDirection="column">
              <CustomRadioButton
                label={option.label}
                checked={field.value === option.value}
                id={`${name}-${option.value}`}
                name={`${name}-${option.value}`}
                value={option.value}
                onChange={() => field.onChange(option.value)}
                disabled={disabled || option.disabled}
                {...other}
              />
              {option?.subTitle && (
                <Box style={{ marginLeft: "25px" }}>
                  <Text variant="bodySm" tone="subdued">
                    {option.subTitle}
                  </Text>
                </Box>
              )}
            </Stack>
          ))}

          {error && <InlineError message={error.message} fieldID={name} />}
        </Stack>
      )}
    />
  );
}
